import React, { useEffect, useState } from 'react';
interface LiabilitiesProps {
  onValueChange?: (totalValue: number) => void;
  onPaymentsChange?: (totalPayments: number) => void;
}
export function Liabilities({
  onValueChange,
  onPaymentsChange
}: LiabilitiesProps) {
  // Initialize with 10 blank liability items
  const [liabilities, setLiabilities] = useState(Array(10).fill(null).map(() => ({
    name: '',
    value: 0,
    payment: 0
  })));
  const totalLiabilities = liabilities.reduce((sum, liability) => sum + (liability.value || 0), 0);
  const totalPayments = liabilities.reduce((sum, liability) => sum + (liability.payment || 0), 0);
  // Call the callbacks whenever totalLiabilities or totalPayments changes
  useEffect(() => {
    if (onValueChange) {
      onValueChange(totalLiabilities);
    }
    if (onPaymentsChange) {
      onPaymentsChange(totalPayments);
    }
  }, [totalLiabilities, totalPayments, onValueChange, onPaymentsChange]);
  const handleNameChange = (index: number, newName: string) => {
    const updatedLiabilities = [...liabilities];
    updatedLiabilities[index] = {
      ...updatedLiabilities[index],
      name: newName
    };
    setLiabilities(updatedLiabilities);
  };
  const handleValueChange = (index: number, valueStr: string) => {
    // Convert input to number, defaulting to 0 if invalid
    const numValue = valueStr === '' ? 0 : Number(valueStr) || 0;
    const updatedLiabilities = [...liabilities];
    updatedLiabilities[index] = {
      ...updatedLiabilities[index],
      value: numValue
    };
    setLiabilities(updatedLiabilities);
  };
  const handlePaymentChange = (index: number, valueStr: string) => {
    // Convert input to number, defaulting to 0 if invalid
    const numValue = valueStr === '' ? 0 : Number(valueStr) || 0;
    const updatedLiabilities = [...liabilities];
    updatedLiabilities[index] = {
      ...updatedLiabilities[index],
      payment: numValue
    };
    setLiabilities(updatedLiabilities);
  };
  return <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100 h-full" data-id="element-164">
      <div className="flex justify-between items-center mb-2" data-id="element-165">
        <h2 className="text-xl font-semibold" data-id="element-166">Liabilities</h2>
        <p className="text-lg font-bold text-red-600" data-id="element-167">
          ${totalLiabilities.toLocaleString()}
        </p>
      </div>
      {/* Column Headers */}
      <div className="flex justify-between mb-3 text-sm font-medium text-gray-500 border-b pb-2" data-id="element-168">
        <span className="w-1/3" data-id="element-169">Liability Name</span>
        <div className="flex justify-between w-2/3" data-id="element-170">
          <span className="mr-12" data-id="element-171">Value</span>
          <span data-id="element-172">Monthly Payment</span>
        </div>
      </div>
      {/* Column Totals */}
      <div className="flex justify-between mb-3 text-sm font-medium" data-id="element-173">
        <span className="w-1/3" data-id="element-174"></span>
        <div className="flex justify-between w-2/3" data-id="element-175">
          <span className="font-bold text-red-600 mr-12" data-id="element-176">
            Total: ${totalLiabilities.toLocaleString()}
          </span>
          <span className="font-bold text-red-600" data-id="element-177">
            Total: ${totalPayments.toLocaleString()}/mo
          </span>
        </div>
      </div>
      <div className="space-y-3" data-id="element-178">
        {liabilities.map((liability, index) => <div key={index} className="flex justify-between items-center p-3 bg-gray-50 rounded-md" data-id="element-179">
            <input type="text" value={liability.name} onChange={e => handleNameChange(index, e.target.value)} placeholder="Liability name" className="text-gray-700 bg-transparent border-b border-transparent focus:border-red-500 focus:outline-none w-1/3" data-id="element-180" />
            <div className="flex items-center" data-id="element-181">
              <span className="mr-1" data-id="element-182">$</span>
              <input type="number" value={liability.value === 0 ? '' : liability.value} onChange={e => handleValueChange(index, e.target.value)} placeholder="0" className="font-medium bg-transparent text-right border-b border-transparent focus:border-red-500 focus:outline-none w-24" data-id="element-183" />
            </div>
            <div className="flex items-center" data-id="element-184">
              <span className="mr-1" data-id="element-185">$</span>
              <input type="number" value={liability.payment === 0 ? '' : liability.payment} onChange={e => handlePaymentChange(index, e.target.value)} placeholder="0" className="font-medium bg-transparent text-right border-b border-transparent focus:border-red-500 focus:outline-none w-24" data-id="element-186" />
            </div>
          </div>)}
      </div>
    </div>;
}